export const FIND_RIPPLES_BY_TAGS = `
  query findRipplesByTags(
    $orgId: String!
    $tags: [String!]
    $canViewOnlyOwn: Boolean!
    $pageSize: Int!
    $lastPageCursor: String = ""
  ) {
    viewer {
      organizationScope(id: $orgId) {
        ripples(
          onlyMine: $canViewOnlyOwn
          tags: $tags
          first: $pageSize
          after: $lastPageCursor
        ) {
          totalCount
          edges {
            node {
              id
              rippleImage {
                id
                thumbnailUrl
              }
              isApproved
            }
            cursor
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;